import React from "react";
import usePrep from "../../components/usePrep";
import { ErrorBox, Loader, TrainingIcon, safeUrl } from "../../components/PortalBits";

function TakeTraining() {
  const { loading, error, items, reload } = usePrep();
  const withTraining = items.filter((i) => i.training);

  return (
    <div className="panel">
      <h2>Recorded Modules</h2>
      <div className="sub">Your enrolled certification's official training program.</div>
      {loading && <Loader />}
      {!loading && error && <ErrorBox message={error} onRetry={reload} />}
      {!loading && !error && items.length === 0 && (
        <div className="empty-state">Enroll in a certification to unlock its training programme.</div>
      )}
      {!loading && !error && items.length > 0 && withTraining.length === 0 && (
        <div className="empty-state">No training programme has been published for your certifications yet.</div>
      )}
      {withTraining.map((item) => {
        const t = item.training;
        const lms = item.training_access ? safeUrl(t.lms_url) : null;
        const enrollUrl = safeUrl(t.enroll_url);
        return (
          <div key={item.exam_code} className="training-card">
            <TrainingIcon />
            <div className="training-body">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
                <div className="training-title">{t.title || `${item.exam_code} Certification Training`}</div>
                <span className="price-tag">{item.training_access ? "Enrolled" : t.price_label || "Paid programme"}</span>
              </div>
              <div className="training-tag">{t.tag || "Official LMS course · Self-paced"}</div>
              {t.description && <div className="training-line">{t.description}</div>}
              <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
                {lms ? (
                  <a className="btn btn-primary" href={lms} target="_blank" rel="noopener noreferrer">Go to LMS</a>
                ) : enrollUrl ? (
                  <a className="btn btn-primary" href={enrollUrl} target="_blank" rel="noopener noreferrer">Enroll to unlock LMS</a>
                ) : (
                  <button type="button" className="btn btn-primary" disabled>Enrollment opens soon</button>
                )}
              </div>
              {!item.training_access && (
                <div className="li-meta" style={{ marginTop: 10 }}>
                  Already purchased? The button switches to "Go to LMS" automatically once enrollment is confirmed.
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TakeTraining;
